
        var result = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js!./compute-dashboard.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vcd/dashboard/compute-dashboard.scss
// module id = k3uX
// module chunks = 0